import React from "react";
import { Box, Typography, Chip, Stack, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { trimmedDate } from "utils/helper";
import dayjs from "dayjs";

const PatientHeader = ({ patient, onBack }) => {
  return (
    <Box
      sx={{
        borderBottom: "1px solid #e5e7eb",
        px: 3,
        py: 2,
        backgroundColor: "#fff",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Box display={"flex"} alignItems={"center"}>
          <Button
            startIcon={<ArrowBackIcon />}
            size="small"
            onClick={onBack}
            variant="outlined"
            sx={{
              textTransform: "none",
              borderRadius: "10px",
              mb: 1,
              px: 1.5,
              borderColor: "#d1d5db",
              color: "#374151",
              backgroundColor: "#fff",
              "&:hover": {
                backgroundColor: "#f9fafb",
                borderColor: "#9ca3af",
              },
            }}
          >
            Back
          </Button>

          <Box ml={2}>
            <Typography variant="h5" fontWeight={600}>
              {`${patient.first_name} ${patient.last_name}`}
            </Typography>

            <Typography variant="body2" color="text.secondary">
              {dayjs().diff(dayjs(patient.dob), "year")}Y - {patient.appt_type}{" "}
              {patient.id}
              <Box component="span" sx={{ mx: 1 }}>
                •
              </Box>
              <Typography
                component="span"
                variant="body2"
                sx={{
                  color: "#10b981",
                  fontWeight: 500,
                }}
              >
                {trimmedDate(patient.dos)} {patient.dos_time}
              </Typography>
            </Typography>
          </Box>
        </Box>

        {/* <Stack
          direction="row"
          spacing={1}
          flexWrap="wrap"
          sx={{ maxWidth: "50%" }}
        >
          {patient.tags?.map((tag, index) => (
            <Chip
              key={index}
              label={tag}
              size="small"
              sx={{
                backgroundColor: "#f3f4f6",
                color: "#374151",
                fontWeight: 500,
                borderRadius: "16px",
              }}
            />
          ))}
        </Stack> */}
      </Box>
    </Box>
  );
};

export default PatientHeader;
